import { Time } from "../Helper/Time";
import { WeekType, WeekTypesNumberToWeekTypes } from "../Helper/Week";

export const PackChargeType = {
    discount: "discount",
    percent: "percent",
    unit: "unit"
} as const;

export const PackChargeTypeStrings = {
    discount: "円値引き",
    percent: "%値引き",
    unit: "コマ分値引き"
}

export type PackChargeType = typeof PackChargeType[keyof typeof PackChargeType];

export interface StudioPack {
    pack_id?: number
    pack_name?: string
    chrcate_id?: number
    chrcate_name?: string
    pack_charge?: number
    pack_charge_type?: PackChargeType
    pack_rvdate_start?: Date
    pack_rvdate_end?: Date
    pack_rvtime_start?: Time
    pack_rvtime_end?: Time
    pack_rvtiming_start?: number
    pack_rvtiming_end?: number
    pack_str_id?: number
    pack_std_id?: number
    pack_std_name?: string
    pack_unit_length?: number
    priority?: number
    week_conditions?: WeekType[]
}

export interface ObjectToStudioPackProps {
    pack_id?: number | string
    pack_name?: string
    chrcate_id?: number | string
    chrcate_name?: string
    pack_charge?: string
    pack_rvdate_start?: string
    pack_rvdate_end?: string
    pack_rvtime_start?: string
    pack_rvtime_end?: string
    pack_rvtiming_start?: number | string
    pack_rvtiming_end?: number | string
    pack_str_id?: number | string
    pack_std_id?: number | string
    pack_std_name?: string
    pack_unit_length?: number | string
    priority?: number
    week_conditions?: number | string
}

export const ObjectToStudioPack = (obj: ObjectToStudioPackProps): StudioPack => {
    let charge: number = 0;
    let chargeType: PackChargeType = PackChargeType.discount;
    if (obj.pack_charge) {
        const pack_charge = /^([0-9]+)\s?([%|U]?)$/.exec(obj.pack_charge);
        if (pack_charge) {
            charge = parseInt(pack_charge[1])
            if (!pack_charge[2]) {
                chargeType = PackChargeType.discount
            } else if (pack_charge[2] == "%") {
                chargeType = PackChargeType.percent
            } else if (pack_charge[2] == "U") {
                chargeType = PackChargeType.unit
            }
        }
    }
    let wc = typeof obj.week_conditions == 'string' ? parseInt(obj.week_conditions) : obj.week_conditions

    return {
        pack_id: typeof obj.pack_id == 'string' ? parseInt(obj.pack_id) : obj.pack_id,
        pack_name: obj.pack_name,
        chrcate_id: typeof obj.chrcate_id == 'string' ? parseInt(obj.chrcate_id) : obj.chrcate_id,
        chrcate_name: obj.chrcate_name,
        pack_charge: charge,
        pack_charge_type: chargeType,
        pack_rvdate_start: obj.pack_rvdate_start ? new Date(obj.pack_rvdate_start) : undefined,
        pack_rvdate_end: obj.pack_rvdate_end ? new Date(obj.pack_rvdate_end) : undefined,
        pack_rvtime_start: obj.pack_rvtime_start ? new Time(obj.pack_rvtime_start) : undefined,
        pack_rvtime_end: obj.pack_rvtime_end ? new Time(obj.pack_rvtime_end) : undefined,
        pack_rvtiming_start: typeof obj.pack_rvtiming_start == 'string' ? parseInt(obj.pack_rvtiming_start) : obj.pack_rvtiming_start,
        pack_rvtiming_end: typeof obj.pack_rvtiming_end == 'string' ? parseInt(obj.pack_rvtiming_end) : obj.pack_rvtiming_end,
        pack_str_id: typeof obj.pack_str_id == 'string' ? parseInt(obj.pack_str_id) : obj.pack_str_id,
        pack_std_id: typeof obj.pack_std_id == 'string' ? parseInt(obj.pack_std_id) : obj.pack_std_id,
        pack_std_name: obj.pack_std_name,
        pack_unit_length: typeof obj.pack_unit_length == 'string' ? parseInt(obj.pack_unit_length) : obj.pack_unit_length,
        priority: typeof obj.priority == 'string' ? parseInt(obj.priority) : obj.priority,
        week_conditions: wc ? WeekTypesNumberToWeekTypes(wc) : undefined
    }
}